<template>
  <!-- 教育机构消息显示列表页面-->
  <div class="main-css">
    <div class="main-box-css-all">
      <div class="main-box">
        <!-- 左边查看信息部分 -->
        <div class="left-box">
          <!-- 主要显示box 滚动条隐藏部分 -->
          <div class="left-main-box">
            <!-- table 部分 -->
            <div class="div-1">
              <!--            图片-->
              <div class="picture">
                <img src="./assets/3unsplash_OH2S9XAcLhc.png">
              </div>
            </div>
            <div class="div-2">
              <!--            图片下面的文字-->
              <div class="text">
                <span>桜病院ー高橋</span>
              </div>
            </div>
            <!--            分割线-->
            <el-divider class="divider"></el-divider>
            <div class="user" >
              <!--              加滚动条-->
              <div class="div-3">
                <!--            搜索框-->
                <div class="search">
                  <el-input
                    placeholder="Search for chats"
                    prefix-icon="el-icon-search"
                    v-model="searchInput"
                    @change="searchMessage"
                  >
                  </el-input>
                </div>
              </div>

              <div class="div-4">
                <img src="./assets/Ellipse 7.png" class="user-photo">
                <ul>
                  <li>
                    <span style="font-size: 14px;margin-left: 7px">王　麗華</span>
                    <span class="people" style="font-size: 3px">2022.02.21 11:50</span>
                    <br><span style="font-size: 13px;opacity: 0.7;margin-left: 7px" >河南医学専門学校</span>
                  </li>
                </ul>
              </div>
              <div class="div-4">
                <img src="./assets/Ellipse 7.png" class="user-photo">
                <ul>
                  <li>
                    <span style="font-size: 14px;margin-left: 7px">王　麗華</span>
                    <span class="people" style="font-size: 3px">2022.02.21 11:50</span>
                    <br><span style="font-size: 13px;opacity: 0.7;margin-left: 7px" >河南医学専門学校</span>
                  </li>
                </ul>
              </div>
              <div class="div-4">
                <img src="./assets/Ellipse 7.png" class="user-photo">
                <ul>
                  <li>
                    <span style="font-size: 14px;margin-left: 7px">王　麗華</span>
                    <span class="people" style="font-size: 8px">2022.02.21 11:50</span>
                    <br><span style="font-size: 13px;opacity: 0.7;margin-left: 7px" >河南医学専門学校</span>
                  </li>
                </ul>
              </div>
              <div class="div-4">
                <img src="./assets/Ellipse 7.png" class="user-photo">
                <ul>
                  <li>
                    <span style="font-size: 14px;margin-left: 7px">王　麗華</span>
                    <span class="people" style="font-size: 8px">2022.02.21 11:50</span>
                    <br><span style="font-size: 13px;opacity: 0.7;margin-left: 7px" >河南医学専門学校</span>
                  </li>
                </ul>
              </div><div class="div-4">
              <img src="./assets/Ellipse 7.png" class="user-photo">
              <ul>
                <li>
                  <span style="font-size: 14px;margin-left: 7px">王　麗華</span>
                  <span class="people" style="font-size: 8px">2022.02.21 11:50</span>
                  <br><span style="font-size: 13px;opacity: 0.7;margin-left: 7px" >河南医学専門学校</span>
                </li>
              </ul>
            </div><div class="div-4">
              <img src="./assets/Ellipse 7.png" class="user-photo">
              <ul>
                <li>
                  <span style="font-size: 14px;margin-left: 7px">王　麗華</span>
                  <span class="people" style="font-size: 8px">2022.02.21 11:50</span>
                  <br><span style="font-size: 13px;opacity: 0.7;margin-left: 7px" >河南医学専門学校</span>
                </li>
              </ul>
            </div>
            </div>
          </div>
        </div>
        <!-- 右边聊天部分 -->
        <div class="right-box">
          <MessageBoxEducation></MessageBoxEducation>
        </div>
      </div>
      <!-- button 部分 -->
      <!--      <div class="main-button">
              <button>{{ $t("collection") }}</button>
            </div>-->
    </div>
  </div>
</template>
<script>
import MessageBox from  "../../components/MessageBox"
import MessageBoxEducation from "../../components/MessageBoxEducation.vue";
export default {
  name: "educationViewMedicalHomepage",
  components: { MessageBoxEducation },
  // components: { MessageBox },
  data() {
    return {
      searchInput: "", //搜索聊天input值
      //列表数据
      tableData: [
        {
          projectTitle: "大至急　看護士助手募集中！！", //案件名
          workLocation: "大宮", //勤務地
          publicationDate: "2022.02.28", //掲載日
          numberViewing: "570", //観覧回数
        },
        {
          projectTitle: "介護士　即入職！", //案件名
          workLocation: "大宮", //勤務地
          publicationDate: "2022.02.28", //掲載日
          numberViewing: "50", //観覧回数
        },
        {
          projectTitle: "大至急　看護士助手募集中！！", //案件名
          workLocation: "大宮", //勤務地
          publicationDate: "2022.02.28", //掲載日
          numberViewing: "70", //観覧回数
        },
        {
          projectTitle: "大至急　看護士助手募集中！！", //案件名
          workLocation: "大宮", //勤務地
          publicationDate: "2022.02.28", //掲載日
          numberViewing: "570", //観覧回数
        },
        {
          projectTitle: "大至急　看護士助手募集中！！", //案件名
          workLocation: "大宮", //勤務地
          publicationDate: "2022.02.28", //掲載日
          numberViewing: "570", //観覧回数
        },
        {
          projectTitle: "大至急　看護士助手募集中！！", //案件名
          workLocation: "大宮", //勤務地
          publicationDate: "2022.02.28", //掲載日
          numberViewing: "590", //観覧回数
        },
        {
          projectTitle: "看護士助手募集", //案件名
          workLocation: "大宮", //勤務地
          publicationDate: "2022.02.28", //掲載日
          numberViewing: "570", //観覧回数
        },
        {
          projectTitle: "大至急　看護士助手募集中！！", //案件名
          workLocation: "大宮", //勤務地
          publicationDate: "2022.02.28", //掲載日
          numberViewing: "57", //観覧回数
        },
        {
          projectTitle: "大至急　看護士助手募集中！！", //案件名
          workLocation: "大宮", //勤務地
          publicationDate: "2022.02.28", //掲載日
          numberViewing: "57", //観覧回数
        },
        {
          projectTitle: "大至急　看護士助手募集中！！", //案件名
          workLocation: "大宮", //勤務地
          publicationDate: "2022.02.28", //掲載日
          numberViewing: "57", //観覧回数
        },
      ],
      projectTitleSearch: "", //案件名搜索框
      workLocationSearch: "", //勤務地搜索框
      publicationDateSearch: "", //掲載日搜索框
      loading: false,
      currentPage: 4, //页数
      pageSize: 7, //每页条数
    };
  },
  created() {},
  computed: {},
  methods: {
    searchMessage() {
      console.log(this.searchInput);
    },
    change(e) {
      this.$forceUpdate();
    },
    //表格排序
    changeTableSort(custom) {
      console.log(custom);
      if (custom.order === "ascending") {
        this.tableData = this.tableData.sort(
          (a, b) => a["numberViewing"] - b["numberViewing"]
        );
      } else if (custom.order === "descending") {
        this.tableData = this.tableData.sort(
          (a, b) => b["numberViewing"] - a["numberViewing"]
        );
      }
    },
    // 案件名search
    handleProjectTitleSearch() {
      console.log("案件名search");
      console.log(this.projectTitleSearch);
    },
    // 勤務地search
    handleWorkLocationSearch() {
      console.log("勤務地search");
      console.log(this.workLocationSearch);
    },
    // 掲載日search
    handlePublicationDateSearch() {
      console.log("掲載日search");
      console.log(this.publicationDateSearch);
    },
    //每页条数下拉框
    handleCommand(command) {
      if (command === "a") {
        this.pageSize = 7;
      } else if (command === "b") {
        this.pageSize = 15;
      } else if (command === "c") {
        this.pageSize = 20;
      } else if (command === "d") {
        this.pageSize = 25;
      }
    },
    // 分页页数变化
    handleCurrentChange() {},
  },
};
</script>
<style scoped>
.main-css {
  width: 100%;
  height: 100%;
  background: #fff;
  display: flex;
  flex-direction: column;
}
.main-box {
  width: 1400px;
  height: 100%;
  margin: 0 auto;
  flex: 1;
  padding-top: 0px;
  box-sizing: border-box;
  overflow: hidden;
}

.main-box-css-all {
  width: 1200px;
  margin: 0 auto;
}
.left-box {
  width: 18%;
  height: 730px;
  overflow: hidden;
  float: left;
  margin-top: 41px;

}
.left-main-box {
  /*position: absolute;*/
  width: 236px;
  height: 718px;
  left: 425px;
  top: 93px;
  background: #51ABFF;
  border-radius: 8px;
  border: 2px solid #51abff;
  overflow: hidden;

}
.one-line-box {
  width: 100%;
  height: 160px;
  display: flex;
  align-items: center;
}
.avt-img {
  width: 160px;
  height: 160px;
  overflow: hidden;
  border-radius: 50%;
}
.big-form-box {
  height: 57px;
  width: 299px;
  border-radius: 8px;
  background: #ffffff;
  border: 2px solid #51abff;
  box-sizing: border-box;
  margin-left: 30px;
  margin-top: 50px;
  position: relative;
}
.certified {
  width: 49px;
  height: 18px;
  text-align: center;
  line-height: 18px;
  background: #fc630c;
  border-radius: 4px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 10px;
  letter-spacing: -0.02em;
  color: #ffffff;
  position: absolute;
  right: 0;
  top: -22px;
}
.big-form-box span {
  height: 24px;
  line-height: 24px;
  background: #fff;
  padding: 0 5px;
  position: absolute;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
}
.other-line-box {
  width: 100%;
  height: 45px;
  margin-top: 24px;
  display: flex;
}
.small-box {
  width: 200px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
  margin-right: 10px;
}
.small-box span {
  height: 24px;
  line-height: 24px;
  background: #fff;
  padding: 0 5px;
  position: absolute;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
}
.big-box {
  width: 292px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.big-box span {
  height: 24px;
  line-height: 24px;
  background: #fff;
  padding: 0 5px;
  position: absolute;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
}
.most-small-box {
  width: 140px;
  height: 44px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.most-small-box span {
  height: 24px;
  line-height: 24px;
  background: #fff;
  padding: 0 5px;
  position: absolute;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
}
.textarea-line-box {
  width: 100%;
  height: 180px;
  margin-top: 24px;
  display: flex;
}
.textarea-box {
  width: 500px;
  height: 178px;
  background: #ffffff;
  border: 2px solid #b2b2b2;
  box-sizing: border-box;
  border-radius: 8px;
  position: relative;
}
.textarea-box span {
  height: 24px;
  line-height: 24px;
  background: #fff;
  padding: 0 5px;
  position: absolute;
  top: -12px;
  left: 15px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  color: #51abff;
}
.table-line {
  margin-top: 24px;
  width: 500px;
  height: 450px;
}
.table-line /deep/ .el-input__inner {
  border: 1px solid transparent;
  padding: 0;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #c9cfda;
}
.number-viewing {
  position: relative;
}
.table-line /deep/ .caret-wrapper {
  position: absolute;
  top: -4px;
  right: 0;
}
.table-line .empty {
  height: 30px;
}
.right-box {
  background: #fff;
  width: 550px;
  height: 650px;
  margin-top: 40px;
  float: left;

}
.main-button {
  width: 500px;
  height: 50px;
  text-align: center;
  margin-top: 20px;
}
.main-button button {
  cursor: pointer;
  height: 40px;
  width: 152px;
  background: #fc630c;
  border-radius: 4px;
  font-family: "Poppins";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #ffffff;
}

.pagination {
  width: 100%;
  height: 50px;
  margin-top: 10px;
  display: flex;
  justify-content: right;
}
.rowsPage {
  width: 180px;
  height: 30px;
  line-height: 30px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #454d59;
  display: flex;
  margin-left: 10px;
}
.rowsPage-css {
  width: 60px;
  height: 26px;
  line-height: 26px;
  background: #ffffff;
  border: 1px solid #b0bac9;
  box-sizing: border-box;
  padding: 0 5px 0 10px;
  margin-left: 12px;
}
.rowsPage /deep/ .el-dropdown-link {
  width: 45px;
  height: 26px;
  display: inline-block;
  line-height: 26px;
}
.rowsPage /deep/ .el-icon-arrow-down {
  float: right;
  line-height: 26px;
}
.picture{
  margin: 0 auto;
  margin-top: 36px;
  margin-bottom: 1px;
  width: 54.29px;
  height: 71.43px;
  left: 510px;
  top: 135.86px;
}
.text{
  margin-top:10px;
  width: 84px;
  height: 45px;
  left: 493px;
  top: 197px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #FFFFFF;
}
.search {
  margin-top: 0px;
  height: 30px;
  width: 500px;
  display: flex;
  justify-content: center;
  align-items: center;

}
.search /deep/ .el-input__inner {
  background: #51abff;
  border-radius: 4px;
  width: 200px;
  height: 24px;
  line-height: 24px;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  letter-spacing: 0.25px;
  color: #FFFFFF;
  border: 1px solid transparent;
}
.search /deep/ .el-input {
  /* width移动输入框的位置*/
  width: 150px;
  margin-bottom: 12px;
  height: 24px;
  line-height: 24px;
  border: 24px solid transparent;
}
.search /deep/ .el-input__icon {
  line-height: 24px;
}
.div-1{
  width: 100%;
  height: 100px;
  background-color: #51abff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.div-2{
  width: 100%;
  height: 20px;
  background-color: #51abff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.div-3{
  width: 100%;
  height: 25px;
  left: 484px;
  top: 239px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #51abff;
  opacity: 0.7;
  /*background-color: rgba(101, 69, 69, 0.26);*/
  display: flex;
  justify-content: center;
  align-items: center;
}
.div-4{
  width: 100%;
  height: 65px;
  display: flex;
  justify-content: center;
  align-items: center;
  display: flex;
}
.div-4 li{
}
.div-4 li span{
  width: 71px;
  height: 20px;
  left: 493px;
  top: 284px;
  font-family: 'Open Sans';
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  /* identical to box height, or 143% */
  letter-spacing: 0.25px;
  color: #FFFFFF;
}
.people{
  font-size: 8px;
  opacity: 0.2;
}
.divider{
  width: 70%;
  height: 0px;
  margin-top: 5px;
  margin-left: 30px;
  margin-bottom: 15px;
  opacity: 0.1;
  border: 1px solid #FFFFFF;
}
.user{
  /*opacity: 0.4;*/
  width: 254px;
  height: 355px;
  overflow-y: scroll;
  padding-right: 17px;
  box-sizing: border-box;
}
.user-photo{
  width: 40px;
  height: 40px;
  left: 444px;
  top: 281px;
  margin-left: 7px;
  margin-right: 3px;
}

</style>



// WEBPACK FOOTER //
// src/pages/educationInstitutionNewsView/index.vue